import styled from 'styled-components';
import {OnSurfaceVariant,PrimaryTextColor,OnPrimary,DefaultPrimaryColor} from '../../Colors';

export default {
	Primary:styled.label`
        color : ${OnSurfaceVariant};
    `,
	Black:styled.label`
        color : ${PrimaryTextColor};
    `,
	OnPrimary:styled.label`
        color : ${OnPrimary};
    `,
	Blue:styled.label`
        color : ${DefaultPrimaryColor};
    `,
	Red:styled.label`
        color : red;
    `,
	Yellow:styled.label`
        color : #FFCC00;
    `
};